/**
 * Allows for translating "healthy" HTTP traffic into errors if the status code
 * fails validation, while retaining the original response.
 */
export class HttpError extends Error {
    constructor(request, response) {
        super(`HTTP request was not successful: ${response.status} '${request.method} ${request.url}' failed; ${response.statusText}`);
        this.name = "HttpError";
        this.request = request;
        this.response = response;
    }
}
//# sourceMappingURL=HttpError.js.map